//Componentes generales
import React, { useCallback, useContext, useEffect, useReducer, useRef } from "react";
import authReducer from "./authReducer";
import authContext from "./authContex";
import { NavLink, useNavigate } from 'react-router-dom';

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getUser, authUser, signUp, confirmEmail, sendEmailToRecoverPassword, validateTokenToOverwritePassword, overwritePassword, updateUser } from "../../api/user";
import { verifyLicense } from '../../api/license';

import { SocketContext } from "../socket/socket";

//Acciones
import { 
    REGISTRO_EXITOSO,
    REGISTRO_ERROR,
    OBTENER_USUARIO,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION,
    LIMPIAR_ERROR,
    MENSAJE_LICENCIA,
    SET_LINKS_APP,
    CONFIRM_EMAIL_EXITOSO,
    CONFIRM_EMAIL_ERROR,
    SEND_EMAIL_TO_RECOVER_PASSWORD_EXITOSO,
    SEND_EMAIL_TO_RECOVER_PASSWORD_ERROR,
    VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_EXITOSO,
    VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_ERROR,
    OVERWRITE_PASSWORD_EXITOSO,
    OVERWRITE_PASSWORD_ERROR,
    SIGNUP_EXITOSO,
    SIGNUP_ERROR,
    NOT_SHOW_TUTO,
    OBTENER_USUARIO_CHANGE_PASSWORD,
    UPDATE_COLUMNS_PREFERENCES_USUARIO,
    UPDATE_AUTOBLOQUEO_USUARIO,
    SET_DICTIONARY,
    SET_GLOBALSETTINGS,
} from "./authActions";
import Swal from "sweetalert2";
import { IS_ADMIN, IS_ADMINWORWTHABMS, IS_MACHINISTIC, IS_MECHANIC, VER_PROCSPROGRAMADOS, VER_TABACTIVOSSUPERVISOR, IS_SOCIO, IS_CANCHERO, IS_GESTOR_RESERVAS, IS_REVISOR, IS_REVISOR_RESERVAS } from "../../utils/permisos";
import { updDictionary } from "../../api/dictionary";
import { updGlobalSettings } from "../../api/globalSettings";

/* 
    State encargado de la gestión de autorización de usuario y licencias.
*/
const AuthState = props => {

   
    //Valores iniciales
    const initialState = {
        token: null,
        autenticado: false,
        usuario: null,
        mensaje: null,
        cargando: true,
        mensajeLicencia: '',
        showTuto: false,
        hasWebServiceConfigured: false,
        dictionary: null,
        globalSettings: null
    };

    const server = useContext(SocketContext);
    const [state, dispatch] = useReducer(authReducer, initialState);
    const userRef = useRef(state.usuario);
    
    //Inicializo navegacion
    const navigate = useNavigate();

    /* 
        Función encargada de registrar un usuario.
    */
    const registrarUsuario = async datos => {

        try{
            const respuesta = await clienteAxios.post('/usuarios', datos);

            dispatch({
                type: REGISTRO_EXITOSO,
                payload: respuesta.data.data
            });

            //Obtener el usuario
            usuarioAutenticado();

        } catch (error) {
            
            const alerta = {
                msg: error.response.data.msg ,
                categoria: 'alerta-error'
            };

            dispatch({
                type:REGISTRO_ERROR,
                payload: alerta
            });
        }
    }

     /* 
        Función que obtiene el usuario en sesión mediante el token asignado al momento de iniciar sesión.
     */
    const usuarioAutenticado = async () => {
        const token = localStorage.getItem('token')
        
        try{
            if(token != undefined && token != null){
                const respuesta = await getUser(token); //clienteAxios.get('/user/auth');

                // Si el backend devuelve un token renovado, guardarlo
                if (respuesta.data.renewedToken) {
                  localStorage.setItem('token', respuesta.data.renewedToken);
                }

                if(respuesta.data.data.mustChangePassword){
                  dispatch({
                    type: OBTENER_USUARIO_CHANGE_PASSWORD,
                    payload: respuesta.data.data
                  });
                  throw new Error("Debe cambiar la contraseña");
                }

                let respLicense = await verificarLicencia();
            
                if(respLicense.vencida != undefined && respLicense.vencida){
                  await cerrarSesion(false);
                  throw new Error('LICENCIA DE USO VENCIDA. Comuníquese con el Administrador.');
                }

                dispatch({
                    type: OBTENER_USUARIO,
                    payload: respuesta.data.data
                });
            }else{
                //throw new Error("No hay un token de inicio de sesion registrado");
            }
        } catch (err) {
          console.log("err");
          console.log(err);
          
            if(String(err).includes('LICENCIA')){
              navigate('/')
              Swal.fire({
                title: String(err),
                icon:'error'
              })
            }
          
          
            if(err.message === "Network Error"){
                dispatch({
                    type: LOGIN_ERROR,
                    payload: {
                        msg: 'Servidor fuera de Servicio. Compruebe conexion o licencia'
                    }
                })
            }
            if(err.message == "Request failed with status code 401"){
              console.log("Error 401 Unauthorized");
            } if(err.message == "Request failed with status code 402"){
              console.log("Error 402 Unauthorized");
            } else{
              dispatch({
                type: LOGIN_ERROR,
                payload:{
                  msg: err.message
                }
              })
            }
        }
    } 

    /* 
        Función que inicia la sesión del usuario despues de superar las validaciones.
        Asigna un token local unico a la sesión.
    */
    const iniciarSesion = async datos => {
      if(datos.userName.trim() !== '' && datos.password.trim() !== '' && datos.tenantId.trim() != '' ) {            
          try{
              const respuesta = await authUser(datos); //clienteAxios.post('/user/auth', datos);
              
              dispatch({
                  type: LOGIN_EXITOSO,
                  payload: respuesta.data.data
              })
              
              localStorage.setItem('token', respuesta.data.data);
              window.dispatchEvent(new Event('auth-changed'));
              return {autenticado: true};
          } catch (error){
            console.log("error");
            console.log(error);
            
            if(error.message == 'Network Error'){
              const alerta = {
                msg: "El Servidor no se encuentra disponible",
                categoria: 'alerta-error'
              };

              dispatch({
                  type:LOGIN_ERROR,
                  payload: alerta
              });

              return {autenticado: false, error:{response:{data:{message:alerta.msg}}}};
            }else{
              if(error.message == "Request failed with status code 402"){
                console.log("Error 402");
              }else{
                const alerta = {
                  msg: error.response.data.errMsg ,
                  categoria: 'alerta-error'
                };
                
                dispatch({
                  type:LOGIN_ERROR,
                  payload: alerta
                });
              }
            }
            return {autenticado:false, error}
          }
        }else{
            const alerta = {
                msg: "Debe Ingresar un Usuario valido con su Contraseña" ,
                categoria: 'alerta-error'
            };

            dispatch({
                type:LOGIN_ERROR,
                payload: alerta
            });
        }
    }

    /* 
        Función encargada de cerrar la sesión del usuario en sesión.
        Elimina el token local de la sesión.
    */
    const cerrarSesion = async (showMessage = true) => {
        await localStorage.removeItem('token');
        window.dispatchEvent(new Event('auth-changed'));
        showMessage && dispatch({
            type: CERRAR_SESION,
            payload: 'Se cerro sesion'
        })
    }

    /* 
        Función que limpia el valor de error.
    */
    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    /* 
        Función que verficia la licencia del cliente.
        No esta en uso.
    */    
    const verificarLicencia = async () => {
      try {
          const respuesta = await verifyLicense(); //clienteAxios.get('/license/verify');
          
          dispatch({
              type: SET_LINKS_APP,
              payload: {hasWebServiceConfigured: respuesta.data.data.hasWebServiceConfigured, globalSettings:respuesta.data.data.globalSettings, dictionary: respuesta.data.data.dictionary}
          })
          
          if(respuesta.data.data.dias <= 10){
            await Swal.fire({
                title: 'Licencia por Vencer!',
                html: `LICENCIA DE USO VENCE ${respuesta.data.data.fechaExpiracion.substring(0,10)}. <br> Comuníquese con el Administrador.`,
                icon: 'warning',
                showConfirmButton: true,
                confirmButtonText: 'Entendido'
            });
          }
          
          return 20;
      } catch (error) {
          return {vencida:true, error:error.response};    
      }
    }


    //Creado Recientemente para Pruebas Gratuitas
    const verificarTenant = (tenantId) => userRef.current != null ? userRef.current.tenantId == tenantId : false;

  /* 
    Función que crea una cuenta despues de superar las validaciones.
  */
  const crearCuenta = async (datos, captcha) => {
    try {
        const respuesta = await signUp({user:datos, captcha}); //clienteAxios.post('/user/signUp', datos);
        console.log(respuesta.data.data);
        dispatch({
          type: SIGNUP_EXITOSO,
          payload: respuesta.data.data,
        });
        return respuesta;
    } catch (error) {
      let mensaje = "Ocurrió un error inesperado.";

      if (error.response?.data?.errMsg) {
        mensaje = error.response.data.errMsg;
      } else if (error.message) {
        mensaje = error.message;
      } else if (error instanceof Error && error.message) {
        mensaje = error.message;
      }

      const alerta = {
        msg: mensaje,
        categoria: "alerta-error",
      };

      dispatch({
        type: SIGNUP_ERROR,
        payload: alerta,
      });

      throw error;
      //return error;
    }
  };

    /* 
        Función que confirma correo electrónico cuando un usuario se da de alta.
    */
        const confirmarEmail = async (token) => {
          try {
              const respuesta = await confirmEmail(token); //clienteAxios.post(`/user/confirmEmail/${token}`);
              console.log(respuesta.data.data);
              dispatch({
                type: CONFIRM_EMAIL_EXITOSO,
                payload: respuesta.data.data,
              });
              return respuesta;
          } catch (error) {
            let mensaje = "Ocurrió un error inesperado.";
      
            if (error.response?.data?.errMsg) {
              mensaje = error.response.data.errMsg;
            } else if (error.message) {
              mensaje = error.message;
            } else if (error instanceof Error && error.message) {
              mensaje = error.message;
            }
      
            const alerta = {
              msg: mensaje,
              categoria: "alerta-error",
            };
      
            dispatch({
              type: CONFIRM_EMAIL_ERROR,
              payload: alerta,
            });
      
            throw error;
            //return error;
          }
        };

    /* 
        Función que envía email de recuperación de contraseña.
    */
        const enviarEmailToRecoverPassword = async (userName,tenantId) => {
          try {
              const respuesta = await sendEmailToRecoverPassword(userName,tenantId); //clienteAxios.put(`/user/sendEmailToRecoverPassword/${userName}`);
              dispatch({
                type: SEND_EMAIL_TO_RECOVER_PASSWORD_EXITOSO,
                payload: respuesta.data.data,
              });
              return respuesta;
          } catch (error) {
            let mensaje = "Ocurrió un error inesperado.";
      
            if (error.response?.data?.errMsg) {
              mensaje = error.response.data.errMsg;
            } else if (error.message) {
              mensaje = error.message;
            } else if (error instanceof Error && error.message) {
              mensaje = error.message;
            }
      
            const alerta = {
              msg: mensaje,
              categoria: "alerta-error",
            };
      
            dispatch({
              type: SEND_EMAIL_TO_RECOVER_PASSWORD_ERROR,
              payload: alerta,
            });
      
            throw error;
            //return error;
          }
        };

    /* 
        Función que valida token cuando un usuario solicita restablecer su contraseña.
    */
        const validarTokenParaCambiarContraseña = async (token) => {
          try {
              const respuesta = await validateTokenToOverwritePassword(token); //clienteAxios.get(`/user/validateTokenToOverwritePassword/${token}`);
              dispatch({
                type: VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_EXITOSO,
                payload: respuesta.data.data,
              });
              return respuesta;
          } catch (error) {
            let mensaje = "Ocurrió un error inesperado.";
      
            if (error.response?.data?.errMsg) {
              mensaje = error.response.data.errMsg;
            } else if (error.message) {
              mensaje = error.message;
            } else if (error instanceof Error && error.message) {
              mensaje = error.message;
            }
      
            const alerta = {
              msg: mensaje,
              categoria: "alerta-error",
            };
      
            dispatch({
              type: VALIDATE_TOKEN_TO_OVERWRITE_PASSWORD_ERROR,
              payload: alerta,
            });
      
            throw error;
            //return error;
          }
        };

    /* 
        Función que cambia contraseña cuando un usuario olvida su contraseña.
    */
        const cambiarContraseña = async (token,password) => {
          try {
              const respuesta = await overwritePassword(token, password); //clienteAxios.put(`/user/overwritePassword/${token}`);
              dispatch({
                type: OVERWRITE_PASSWORD_EXITOSO,
                payload: respuesta.data.data,
              });
              return respuesta;
          } catch (error) {
            let mensaje = "Ocurrió un error inesperado.";
      
            if (error.response?.data?.errMsg) {
              mensaje = error.response.data.errMsg;
            } else if (error.message) {
              mensaje = error.message;
            } else if (error instanceof Error && error.message) {
              mensaje = error.message;
            }
      
            const alerta = {
              msg: mensaje,
              categoria: "alerta-error",
            };
      
            dispatch({
              type: OVERWRITE_PASSWORD_ERROR,
              payload: alerta,
            });
      
            throw error;
            //return error;
          }
        };

      const notShowTuto = () => {
        dispatch({
          type: NOT_SHOW_TUTO
        })
      }

    //Fin Creado Reciente

    /* Validaciones Roles */
    //Incluye Admin.
    const checkIfAdmin = () => {
      if(state.usuario) return IS_ADMIN.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT));
      else return false;
    }

    //Incluye Admin y Admin Sin ABMs.
    const checkIfAdminOrAdminNoABMs = () => {
      if(state.usuario) return IS_ADMINWORWTHABMS.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT));
      else return false;
    }

    const checkIfSupervisor = () => {
        if(state.usuario) return VER_TABACTIVOSSUPERVISOR.some(sup => state.usuario.userType.map(u => u.typeName).includes(sup));
        else return false;
    }

    //Incluye Admin, Admin Sin ABMs y Supervisor.
    const checkIfSupervisorOrAdmin = () => {
      if(state.usuario) return VER_PROCSPROGRAMADOS.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT));
      else return false;
    }
    
    const checkIfSupervisorOrAdminOrAdminNoABMs = () => {
      if(state.usuario) return VER_PROCSPROGRAMADOS.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT));
      else return false;
    }

    const checkIfOnlyRevisor = () => {
      if(state.usuario) return (state.usuario.userType.length == 1 && IS_REVISOR.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT)));
      else return false;
    }

    const checkIfMachinistic = () => {
      if(state.usuario) return IS_MACHINISTIC.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT));
      else return false;
    }
    
    const checkIfMechanic = () => {
      if(state.usuario) return IS_MECHANIC.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT));
      else return false;
    }

    const checkIfSocio = () => {
      if(state.usuario) return IS_SOCIO.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT));
      else return false;
    }

    const checkIfCanchero = () => {
      if(state.usuario) return IS_CANCHERO.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT));
      else return false;
    }

    const checkIfGestorReservas = () => {
      if(state.usuario) return IS_GESTOR_RESERVAS.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT));
      else return false;
    }

    //Revisor de Reservas: solo accede a Reservas de Canchas.
    const checkIfRevisorReservas = () => {
      if(state.usuario) return IS_REVISOR_RESERVAS.some(uT => state.usuario.userType.map(u => u.typeName).includes(uT));
      else return false;
    }

    const updateGlobalSettings = async (gSettingsUpdated, companyImg = null, actionOverImg = '') => {
      try {
        let res = await updGlobalSettings(gSettingsUpdated, companyImg, actionOverImg);
        if(res?.data?.globalSettings){
          dispatch({
            type:SET_GLOBALSETTINGS,
            payload: res.data.globalSettings
          });
          return true;
        }else return false;
      } catch (error) {
        console.log("error en updateGlobalSettings en authState");
        console.log(error);
      }
    }

    /*
      Actualiza el autobloqueo de reservas del usuario logueado y refleja el nuevo valor en el contexto.
      Devuelve true si se pudo guardar, false en caso contrario.
    */
    const updateAutobloqueoReservas = async (autobloqueoReservas) => {
      try {
        await updateUser({ _id: state.usuario._id, autobloqueoReservas });
        dispatch({
          type: UPDATE_AUTOBLOQUEO_USUARIO,
          payload: autobloqueoReservas
        });
        return true;
      } catch (error) {
        console.log("error en updateAutobloqueoReservas en authState");
        console.log(error);
        return false;
      }
    }

    const getValorActualFromDictionary = (text) => {
      let valorToReturn = Object.values(state.globalSettings.dictionary ?? {}).flat().find(w => w.original == text);
      return valorToReturn?.actual ?? text;
    }

    const logout = () => {
      localStorage.removeItem("token");
      window.dispatchEvent(new Event('auth-changed'));
      window.location.replace("/login");
    };

    useEffect(() => {
      const syncLogout = (event) => {
        if (event.key === "token") {
          if (event.newValue === null) {
            logout(); // logout desde otra pestaña
          }
          // Si el token cambió (renovación desde otra pestaña), no hacer nada.
          // El token ya está actualizado en localStorage y se usará en la próxima request.
        }
      };

      window.addEventListener("storage", syncLogout);
      return () =>
        window.removeEventListener("storage", syncLogout);
    }, []);

    useEffect(()=>{
        userRef.current = state.usuario;
    },[state.usuario])

    useEffect(()=>{
      usuarioAutenticado()
    },[]);

    useEffect(() => {
      if(server){

        server.on('globalSettingsUpdated', ({tenantId, globalSettings}) =>{
          const update = verificarTenant(tenantId);
          if(update){
            console.log("Recibo el evento del Real Time Server globalSettingsUpdated");
            dispatch({
              type:SET_GLOBALSETTINGS,
              payload: globalSettings
            })
          }
        })

        server.on('columnsPreferencesChanged', ({ preferencesSaved }) => {
            console.log("evento columnsPreferencesChanged recibido");
            dispatch({
                type: UPDATE_COLUMNS_PREFERENCES_USUARIO,
                payload: preferencesSaved
            })
        });
  
        return () => {
          server.off('globalSettingsUpdated');
          server.off('columnsPreferencesChanged');
        }
      }

  },[server])

    return(
        <authContext.Provider
            value={{
                token: state.token,
                autenticado: state.autenticado,
                usuario: state.usuario,
                mensaje: state.mensaje,
                cargando: state.cargando,
                mensajeLicencia: state.mensajeLicencia,
                showTuto: state.showTuto,
                dictionary: state.dictionary,
                globalSettings: state.globalSettings,
                hasWebServiceConfigured: state.hasWebServiceConfigured,
                notShowTuto,
                registrarUsuario,
                iniciarSesion,
                usuarioAutenticado,
                cerrarSesion,
                limpiarError,
                verificarLicencia,
                verificarTenant,
                crearCuenta,
                confirmarEmail,
                enviarEmailToRecoverPassword,
                validarTokenParaCambiarContraseña,
                cambiarContraseña,
                checkIfAdmin,
                checkIfAdminOrAdminNoABMs,
                checkIfOnlyRevisor,
                checkIfSupervisor,
                checkIfMachinistic,
                checkIfMechanic,
                checkIfSocio,
                checkIfCanchero,
                checkIfGestorReservas,
                checkIfRevisorReservas,
                checkIfSupervisorOrAdmin,
                updateGlobalSettings,
                updateAutobloqueoReservas,
                getValorActualFromDictionary
            }}
        >
            {props.children}
        </authContext.Provider>
    )
    
}

export default AuthState;